export const firebaseConfig = {
  apiKey: "AIzaSyCAK5kZsy5UYxfHgA6IK8Q_uaTpa62P2ik",
  authDomain: "greatday-qa.firebaseapp.com",
  databaseURL: "https://greatday-qa.firebaseio.com",
  projectId: "greatday-qa",
  storageBucket: "greatday-qa.appspot.com",
  messagingSenderId: "322321454251",
  appId: "1:322321454251:web:cfb6d663c52accb5",
  vapidKey: 'BHuTXcCQeqAA7zXQS3ALI_Pqd6f0oHTgTODjLJyW8ZZy0GIWSSVETH0gVstfsoiUqJauarHz_cAGtXhTipRpegI'
};



// WEBPACK FOOTER //
// ./src/providers/fcm-service/environment.ts